import { render, staticRenderFns } from "./ViewProperty.vue?vue&type=template&id=70ac7705&"
import script from "./ViewProperty.vue?vue&type=script&lang=js&"
export * from "./ViewProperty.vue?vue&type=script&lang=js&"
import style0 from "./ViewProperty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports